import { getBudgetStatusLabel } from '../../../../enums/budgetStatus';
import { getStatusColor, isStatusWithBadge } from '../../utils';

interface IStatusBadgeProps {
  status: string;
}

const StatusBadge = (props: IStatusBadgeProps) => {
  const displayStatus = getBudgetStatusLabel(props.status);
  
  if (isStatusWithBadge(props.status)) {
    return (
      <span
        className={`min-w-60 px-3 py-2 rounded-full text-size-12 text-center inline-block whitespace-nowrap ${getStatusColor(
          props.status
        )}`}
      >
        {displayStatus}
      </span>
    );
  }

  return <span>{displayStatus}</span>;
};

export default StatusBadge;

